"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    if (typeof _jquery2.default.fn.dataTable !== 'function') return;

    (0, _jquery2.default)(this).find("[data-table]").each(function () {
        return (0, _create2.default)(this);
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _create = require('../data-tables/create');

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/data-table.js
// module id = 494
// module chunks = 0